module.exports = __webpack_public_path__ + "0bace979da483a58833da5218ce7eb48.MP3";